import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizacionesService } from '@app/_services/organizaciones.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '@app/_services/menu.service';
import { PublicacionesService } from '@app/_services/publicaciones.service';
import { IdiomasService } from '@app/_services/idiomas.service';
import { Ente } from '@app/_models/ente';
import { Categoria } from '@app/_models/categoria';
import { Idioma } from '@app/_models/idioma';
import { Noticia, NoticiaTraduccion } from '@app/_models/noticia';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { x } from '@progress/kendo-svg-icons';
import { AlertService, DepartamentosService } from '@app/_services';
import { Recinto, RecintoTrad, Sala } from '@app/_models/recinto';
import { RecintosService } from '@app/_services/recintos.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { RestauranteService } from '@app/_services/restaurante.service';
import { Restaurante } from '@app/_models/restaurante';

@Component({
  selector: 'app-resturante-editar',
  templateUrl: './resturante-editar.component.html',
})
export class ResturanteEditarComponent implements OnInit {
  listaIdiomas: Idioma[] = [];
  myRecinto: Restaurante = new Restaurante();
  nombreRecinto: string = '';
  descripcionRecinto: string = '';
  imagenB64: string = '';
  selectedIdioma: Idioma;
  recintoActivo: boolean = true;
  filePath: string;

  lang;
  private translate: TranslateService;
  idOrg: string;
  idRecinto: number;
  constructor(
    private restauranteService: RestauranteService,
    private idiomaService: IdiomasService,
    private organizacionService: OrganizacionesService,
    private menuService: MenuService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    translate: TranslateService,
    private translateService: TranslateService
  ) {
    this.translate = translate;
    this.menuService.titulo = this.translate.instant('recintos.cabecera');
  }

  ngOnInit(): void {
    this.idOrg = this.route.snapshot.params['idorg'];
    this.idRecinto = this.route.snapshot.params['idrecinto'];
    this.idiomaService
      .getIdiomasFromEnte(this.idOrg)
      .subscribe((resultidiomas) => {
        this.listaIdiomas = resultidiomas.data;
        if (this.listaIdiomas.length > 0) {
          this.selectedIdioma = this.listaIdiomas[0];
          //GET RECINTO
          this.restauranteService
            .GetRestauranteByIdLang(this.idRecinto, this.selectedIdioma.codigo)
            .subscribe((resultRec) => {
              console.log(resultRec);
              this.myRecinto = resultRec.data[0];
              this.nombreRecinto = resultRec.data[0].nombre;
              this.descripcionRecinto = resultRec.data[0].descripcion;
              this.recintoActivo = resultRec.data[0].activo;
              this.filePath=resultRec.data[0].urlImagen;
            });
        }
      });
  }

  loadRecinto(value, dropDownControl: DropDownListComponent) {
    //dropDownControl.writeValue("old value");
    console.log('Cargando Recinto Idioma :' + value.codigo);
    this.restauranteService
      .GetRestauranteByIdLang(this.idRecinto, this.selectedIdioma.codigo)
      .subscribe((result) => {
        this.nombreRecinto = result.data[0].nombre;
        this.descripcionRecinto = result.data[0].descripcion;
        this.recintoActivo = result.data[0].activo;
      });
  }

  btnActualizarRecinto() {
    if (this.nombreRecinto==null || this.nombreRecinto.length < 1 || this.descripcionRecinto==null || this.descripcionRecinto.length < 1) {
      this.alertService.info(
        this.translateService.instant('recintos.validacion')
      );
      return;
    }


    if(this.filePath!=this.myRecinto.urlImagen){
      console.log('Obteniendo en BASE64...');
      this.myRecinto.urlImagen = this.filePath.split(',')[1]; //Borramos cabecera data: base
      this.myRecinto.updateFoto=true;
    }
    this.myRecinto.activo = this.recintoActivo;
    this.myRecinto.nombre = this.nombreRecinto;
    this.myRecinto.descripcion = this.descripcionRecinto;
    this.myRecinto.idIdioma = this.selectedIdioma.codigo;

    this.restauranteService
      .updateRestaurante(this.myRecinto)
      .subscribe((resultUpdate) => {
        console.log(resultUpdate);
        if (!resultUpdate.error) {
          this.alertService.success(
            this.translateService.instant('recintos.successupdate')
          );
        } else {
          this.alertService.error(
            this.translateService.instant('recintos.errorupdate')
          );
        }
      });
  }

  //Imagen

  imagePreview(e) {
    const file = (e.target as HTMLInputElement).files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.filePath = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  btnCancelar() {
    this.router.navigate(['restaurantes']);
  }

  navigateGestionComidas(){
    this.router.navigate([
      'comidas',
      { idorg: this.idOrg, idrestaurante:this.idRecinto },
    ]);
  }
  navigateGesComedores(){
    this.router.navigate([
      'comedores',
      { idorg: this.idOrg, idrestaurante:this.idRecinto },
    ]);
  }

  navigateGesMesas(){
    this.router.navigate([
      'mesas',
      { idorg: this.idOrg, idrestaurante:this.idRecinto },
    ]);
  }
  
}
